import { render, staticRenderFns } from "./FormCauHoi.vue?vue&type=template&id=2b58cc73&scoped=true&"
import script from "./FormCauHoi.vue?vue&type=script&lang=js&"
export * from "./FormCauHoi.vue?vue&type=script&lang=js&"
import style0 from "./FormCauHoi.vue?vue&type=style&index=0&id=2b58cc73&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b58cc73",
  null
  
)

export default component.exports